import { API_BASE_URL } from './apiConfig';

const API_BASE = API_BASE_URL;

export const publicApi = {
  // Get list of public letters (first 5, no auth)
  async getPublicLetters() {
    const response = await fetch(`${API_BASE}api/letters/public/list`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.detail || 'Failed to fetch letters');
    }

    return response.json();
  },

  // Get raw HTML for a public letter (no auth)
  getPublicLetterUrl(letterId) {
    return `${API_BASE}api/letters/raw/public/${letterId}`;
  },

  // Get public quiz for letter #1 (no auth)
  async getPublicQuiz() {
    const response = await fetch(`${API_BASE}api/quiz/public`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.detail || 'Failed to fetch quiz');
    }

    return response.json();
  },

  // Submit public quiz (no auth, results not stored in DB)
  async submitPublicQuiz(answers, timeTaken = 0) {
    const response = await fetch(`${API_BASE}api/quiz/public/submit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        answers: answers,
        time_taken: timeTaken
      })
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.detail || 'Failed to submit quiz');
    }

    return response.json();
  },

  // Sync anonymous quiz results to logged-in user account
  async syncQuizResults(email, quizData) {
    const response = await fetch(`${API_BASE}api/quiz/sync?email=${encodeURIComponent(email)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(quizData)
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.detail || 'Failed to sync quiz results');
    }

    return response.json();
  }
};

// localStorage helpers for anonymous quiz results
export const anonymousQuizStorage = {
  STORAGE_KEY: 'prepletter_pending_quiz_results',

  save(quizData) {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(quizData));
    } catch (e) {
      console.error('Failed to save quiz results to localStorage:', e);
    }
  },

  get() {
    try {
      const data = localStorage.getItem(this.STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (e) {
      console.error('Failed to read quiz results from localStorage:', e);
      return null;
    }
  },

  clear() {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
    } catch (e) {
      console.error('Failed to clear quiz results from localStorage:', e);
    }
  },

  hasPending() {
    return this.get() !== null;
  }
};

export default publicApi;
